import { Component, ElementRef, HostListener, Inject, Input, OnInit, Optional, SimpleChanges, ViewChild } from '@angular/core';
import { TipoFirmante } from '../../../../envios/models/tipo-firmante';
import { FirmanteNif } from '../../../models/firmante-nif';
import { DatosConfiguracionDocumentosService } from '../../../services/datos-configuracion-documentos.service';
import { dropOrigin, overlayElementSize } from '../../../services/formulario-documento-coordenadas';
import { MODO_ENVIO_SIMPLE } from '../../../services/modo-envio-simple.token';
import { casillaOverlayStyle } from '../../configuracion-panel-firmantes-unificado/firmante-color.tokens';

@Component({
  selector: 'app-casillas-temporal',
  templateUrl: './casillas-temporal.component.html',
  styleUrls: ['./casillas-temporal.component.css']
})
export class CasillasTemporalComponent implements OnInit {

  @Input() posicionCasilla: {
    mostrar: boolean,
    left: number,
    top: number,
    firmante: TipoFirmante,
    nombre: string,
    orden: number,
    valorOpcionSeleccionada: string,
    obligatorio: boolean,
    idNombreFormulario: number | null
  }
  @ViewChild('draggableIcon') draggableIcon: ElementRef;
  @ViewChild('draggableDiv') draggableDiv: ElementRef;
  @ViewChild('draggableHref') draggableHref: ElementRef;
  casillaPosition: { left: number, top: number, height: number, width: number };
  casillaEnviar: any;
  isDragging: boolean = false;
  clientX: number = 0;
  clientY: number = 0;
  initialX: number = 0;
  initialY: number = 0;
  xOffset: number = 0;
  yOffset: number = 0;
  currentX: number = 0;
  currentY: number = 0;
  finalX: number = 0;
  finalY: number = 0;

  constructor(
    private datosConfiguracionDocumentosService: DatosConfiguracionDocumentosService,
    @Optional() @Inject(MODO_ENVIO_SIMPLE) private modoEnvioSimple: boolean
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges){
    if(changes.posicionCasilla.currentValue.firmante){
      this.posicionCasilla = changes.posicionCasilla.currentValue
    }
  }

  get boxStyle(): Record<string, string> {
    const highlight = this.isFormularioHighlighted();
    return {
      top: `${this.posicionCasilla.top}px`,
      left: `${this.posicionCasilla.left}px`,
      width: '40px',
      height: '40px',
      ...casillaOverlayStyle(this.posicionCasilla.firmante?.codigo, highlight),
    };
  }

  private isFormularioHighlighted(): boolean {
    const current = this.datosConfiguracionDocumentosService.getFormularioHighlight();
    if (!current) {
      return false;
    }
    return (
      current.firmanteCodigo === this.posicionCasilla.firmante?.codigo &&
      current.idNombreFormulario === this.posicionCasilla.idNombreFormulario
    );
  }

  @HostListener('mousedown', ['$event']) onMouseDown(event:any){
    if(event.target === this.draggableDiv.nativeElement || event.target === this.draggableIcon.nativeElement){
      if(this.posicionCasilla.mostrar){
        this.draggableDiv.nativeElement.style.display = 'flex';
        this.isDragging = true;
        this.clientX = this.posicionCasilla.left;
        this.clientY = this.posicionCasilla.top;
        this.initialX = this.posicionCasilla.left - this.xOffset;
        this.initialY = this.posicionCasilla.top - this.yOffset;
      }
    }
  }

  @HostListener('document:mousemove', ['$event']) onMouseMove(event: any) {
    if (this.isDragging) {
      this.currentX = event.clientX - this.initialX - 20;
      this.currentY = event.clientY - this.initialY - 20;
      this.xOffset = this.currentX;
      this.yOffset = this.currentY;
      this.finalX = this.currentX + this.posicionCasilla.left;
      this.finalY = this.currentY + this.posicionCasilla.top - 50;
      const rect = this.draggableDiv.nativeElement.getBoundingClientRect();
      const size = overlayElementSize(this.draggableDiv.nativeElement);
      const width = size.width || rect.width || 120;
      const height = size.height || rect.height || 24;
      this.casillaPosition = {
        left: this.finalX,
        top: this.finalY,
        height,
        width
      }

      this.setTransform();
    }
  }

  //enviamos la posición final a casillas-dibujo a través del observable del servicio DatosConfiguracionDocuemntosService
  @HostListener('document:mouseup', ['$event']) onMouseUp(event: any) {
    this.isDragging = false;
    if (this.draggableIcon && (event.target === this.draggableIcon.nativeElement || event.target === this.draggableDiv.nativeElement || event.target === this.draggableHref.nativeElement)) {
      this.finalX = this.currentX + this.posicionCasilla.left;
      this.finalY = this.currentY + this.posicionCasilla.top;
      const rect = this.draggableDiv.nativeElement.getBoundingClientRect();
      const size = overlayElementSize(this.draggableDiv.nativeElement);
      const width = size.width || rect.width || 120;
      const height = size.height || rect.height || 24;
      this.casillaPosition = {
        left: this.finalX,
        top: this.finalY,
        height,
        width
      }
      this.datosConfiguracionDocumentosService.casillaPosition = this.casillaPosition;
      this.actualizarDocPositionDesdeVista();
      // if(this.datosConfiguracionDocumentosService.isDentro('casillas-temporal', this.casillaPosition)) sustitido por actualizarDocPositionDesdevista();
      // Do not block creation here: bounds checks in this phase are sensitive to layout/scroll
      // and can intermittently reject valid drops after complex UI state changes.
      {
        const origen = dropOrigin(this.modoEnvioSimple, this.datosConfiguracionDocumentosService.docPosition);
        this.casillaEnviar = {
          x: this.casillaPosition.left - origen.left,
          y: this.casillaPosition.top - origen.top,
          width: this.casillaPosition.width,
          height: this.casillaPosition.height,
          firmante: this.posicionCasilla.firmante,
          nombre: this.posicionCasilla.nombre,
          orden: this.posicionCasilla.orden,
          valorOpcionSeleccionada: this.posicionCasilla.valorOpcionSeleccionada ?? '',
          obligatorio: this.posicionCasilla.obligatorio ?? false,
          idNombreFormulario: this.posicionCasilla.idNombreFormulario
        }
        this.datosConfiguracionDocumentosService.transferirDatosCasilla(this.casillaEnviar)
      }
      this.posicionCasilla.mostrar = false;
    }
  }

  private actualizarDocPositionDesdeVista(): void {
    const pdfViewerElement = window.document.querySelector('.pdf-viewer') as HTMLElement;
    if (!pdfViewerElement) return;
    const { left, top, height, width } = pdfViewerElement.getBoundingClientRect();
    this.datosConfiguracionDocumentosService.docPosition = { left, top, height, width };
  }

  setTransform() {
    this.draggableDiv.nativeElement.style.transform = `translate3d(${this.currentX}px, ${this.currentY}px, 0)`;
  }

}
